<template>
  <div class="site-title">
    <a href="/" title="PSCO Application Portal" aria-label="PSCO Application Portal">
      <SiteLogoText />
    </a>
  </div>
</template>

<script setup>
import SiteLogoText from './SiteLogoText.vue'
</script>
